export default __webpack_public_path__ + "images/FA.4f0a486.png";